import { createContext } from 'react'

interface FnsContextType {
  mode: 'survey' | 'form'
}

const FnsContext = createContext<FnsContextType>({
  mode: 'form',
})

function FnsProvider({
  children,
  mode,
}: {
  children: React.ReactNode
  mode: 'survey' | 'form'
}) {
  return <FnsContext.Provider value={{ mode }}>{children}</FnsContext.Provider>
}

export { FnsContext, FnsProvider }
